// Suggestions for the line-item description box: saved services, the client's
// projects and everything billed before (latest price wins), so typing a few
// letters of a service name fills in its price, HSN/SAC, tax and details.

import { num, projectLine } from "./utils";

const key = (s) => String(s || "").trim().toLowerCase().replace(/\s+/g, " ");

export function buildCatalog(store, { clientId = "", excludeId = "" } = {}) {
  const out = new Map();
  const add = (k, entry) => {
    if (!k || out.has(k)) return;
    out.set(k, entry);
  };

  // 1. saved services (any client) and this client's projects
  for (const p of store.projects || []) {
    const isService = p.kind === "service";
    if (!(isService && (!p.clientId || p.clientId === clientId)) && !(clientId && p.clientId === clientId)) continue;
    const description = projectLine(p);
    add(key(description), {
      description,
      source: isService ? "Service" : "Project",
      line: { description, details: p.details || "", hsn: p.hsn || "", rate: num(p.rate), taxRate: p.taxRate, tag: p.tag || "", qty: num(p.qty) || 1, projectId: p.id },
    });
  }

  // 2. lines from earlier documents, newest first (same client first)
  const docs = [...(store.invoices || [])]
    .filter((i) => i.id !== excludeId && i.status !== "cancelled")
    .sort((a, b) => (clientId ? (b.clientId === clientId) - (a.clientId === clientId) : 0) || String(b.date || "").localeCompare(String(a.date || "")));
  for (const inv of docs) {
    for (const l of inv.items || []) {
      const description = String(l.description || "").trim();
      if (!description) continue;
      add(key(description), {
        description,
        source: inv.clientId === clientId && clientId ? "This client" : "Billed before",
        currency: inv.currency,
        date: inv.date,
        line: { description, details: l.details || "", hsn: l.hsn || "", rate: num(l.rate), taxRate: l.taxRate, tag: l.tag || "", qty: 1 },
      });
    }
  }
  return [...out.values()];
}

// Best matches for what has been typed: whole-text prefix, then word prefix, then anywhere.
export function matchCatalog(catalog, text, limit = 8) {
  const q = key(text);
  if (q.length < 1) return [];
  const starts = [];
  const word = [];
  const has = [];
  for (const c of catalog) {
    const k = key(c.description);
    if (k === q) continue; // already typed in full
    if (k.startsWith(q)) starts.push(c);
    else if (k.split(/[\s\-–/(),]+/).some((w) => w.startsWith(q))) word.push(c);
    else if (k.includes(q) || key(c.line.details).includes(q)) has.push(c);
  }
  return [...starts, ...word, ...has].slice(0, limit);
}
